import { useState, useEffect } from 'react';

/**
 * Hook pour détecter les media queries
 * @param query - La media query CSS (ex: "(max-width: 768px)")
 * @returns boolean - true si la media query correspond
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(query);

    // Mettre à jour l'état initial
    setMatches(mediaQuery.matches);

    // Handler pour les changements
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Écouter les changements
    mediaQuery.addEventListener('change', handler);

    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, [query]);

  return matches;
}
